import React, { Component } from 'react';

export default class AfterAbout extends Component {
  render() {
    return (
      <section className='about'>
        <header className='about__title'>
          ЧТО ЭТО?
        </header>
        <p className='about__p'>
          <span className='about__conference-name'>
            HappyDev-lite&nbsp;
          </span>
          &#8212; большая бесплатная конференция о настоящем и будущем IT <div className='about-br'>в России и мире, которая прошла в 5-й раз!</div>
        </p>
        <p className='about__p'>
          Участники &#8212; это школьники и студенты профильных образовательных учреждений, планирующие связать свою жизнь с информационными технологиями.
        </p>
        <p className='about__p'>
          Осенью 2016 конференция прошла в 2 дня. Первый день посвящен web-дизайну, второй &#8212; разработке программного обеспечения. Конференцию посетило около 500 человек. Кроме 20 докладов от ведущих специалистов и руководителей
          IT&ndash;компаний Омска, участники смогли лично пообщаться на стендах с представителями спонсоров и партнеров и узнать о курсах, стажировках <div className='about-br-mobile'>и вакансиях в Омских компаниях.</div>
        </p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/AfterAbout.js